import Button from '@propertypal/web-ui/src/buttons/Button';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Container, ContentText, BespokeImage } from './Bespoke.style';

interface BespokeProps {
  dev?: boolean;
}

const Bespoke: React.FC<BespokeProps> = ({ dev }) => {
  return (
    <Container dev={dev}>
      <PageWrapper>
        <ContentText dev={dev}>
          <SubHeading mb={45} fontSize={60}>
            {dev ? (
              `Develop a successful online presence…`
            ) : (
              <>
                Should you choose a <span>template</span> or a <span>bespoke</span> design?
              </>
            )}
          </SubHeading>
          <Text fontSize={24} mb={45}>
            {dev ? (
              <>
                A professional and engaging online presence is an essential tool for any construction company that wants
                to generate more leads, increase sales and thrive in the competitive building sector.
              </>
            ) : (
              <>
                While our range of templates cater to a diverse range of agent requirements, our bespoke designs can
                offer endless possibilities to set you apart.
              </>
            )}
          </Text>
          <Button
            onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
            maxWidth="300px"
            testID="scroll-to-button"
          >
            Let&apos;s chat
          </Button>
        </ContentText>
        <BespokeImage dev={dev} />
      </PageWrapper>
    </Container>
  );
};

export default Bespoke;
